import { Environment } from '../config/environment';
import { Backend } from './Backend';
import { ICustomPage, IMenu } from './models/AndromeTV.types';
import { CustomPageParam } from './CmsApi.types';

export class NavigationApi {
  /**
   * Retrieve the menu for the specified catalogId
   */
  static menu(backend: Backend, catalogId: string): Promise<IMenu> {
    const url = backend.makeUrl('cms/v1/menu', { deviceType: Environment.system, catalogId: catalogId });
    return backend.getJson(url, backend.bearer) as Promise<IMenu>;
  }

  /**
   * Retrieve a custom page from the backend
   */
  static customPage(backend: Backend, pageId: string, param: CustomPageParam): Promise<ICustomPage> {
    const queryParam = {
      deviceType: Environment.system,
      ...param,
    };
    const url = backend.makeUrl(`cms/v2/custom-page/${encodeURIComponent(pageId)}`, queryParam);
    return backend.getJson(url, backend.bearer) as Promise<ICustomPage>;
  }
}
